// extracted by mini-css-extract-plugin
export default {"FormControl_Validation":"search-input-module__FormControl_Validation--gNUjj"};